import React from 'react';
import styled from '@xstyled/styled-components';
import DOMPurify from 'dompurify';
import { ProfilePicture } from '~/training/sequence/templates/items/chatBot/components/ui/ProfilePicture';

const Header = styled.header`
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 18px 12px;
  border-bottom: 1px solid #e6e8eb;
`;

const HeaderImageWrapper = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  overflow: hidden;
`;

const HeaderTitle = styled.h2`
  font-family: ralewayBold;
  font-size: 16px;
  text-align: center;
  color: ${p => p.theme.colors.black};
`;

interface ChatHeaderProps {
  logoSrc?: string;
  title: string;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ logoSrc, title }) => {
  const sanitizedTitle = DOMPurify.sanitize(title, {
    USE_PROFILES: { html: true }
  });

  return (
    <Header>
      {logoSrc && (
        <HeaderImageWrapper aria-hidden={true}>
          <ProfilePicture src={logoSrc} alt="" aria-hidden={true} />
        </HeaderImageWrapper>
      )}
      <HeaderTitle dangerouslySetInnerHTML={{ __html: sanitizedTitle }} />
    </Header>
  );
};
